import React, { useEffect, useState } from 'react';
import { bookingApi } from '../../utils/bookingApi';
import { listOf } from '../../utils/sessionTypes';
import './ApprovalsWaiting.css';

// On the timetable: tells a family why they can't see any sessions yet
// (every kind of session the club runs needs a coach's approval)
export default function ApprovalWaitNotice() {
  const [wait, setWait] = useState(null);
  useEffect(() => {
    bookingApi.getMyApprovalWait().then(res => setWait(res.data)).catch(() => {});
  }, []);
  if (!wait?.gymnasts?.length) return null;
  const them = wait.gymnasts.length === 1 ? wait.gymnasts[0] : 'them';
  return (
    <div className="approval-wait" role="status">
      <strong>Sessions will show here once a coach has approved {listOf(wait.gymnasts)}.</strong>
      <span> Every session needs approval first ({listOf(wait.types, 'or')}). The coaches have been told, so there's nothing you need to do. If it's been a few days, ask a coach to approve {them}.</span>
    </div>
  );
}
